export default {
      id: "icon-peace-usage",
      viewBox: "0 0 79.2 110.9",
      url: __webpack_public_path__ + "icons.svg#icon-peace",
      toString: function () {
        return this.url;
      }
    }